import { useState } from "react";
import { toast } from "sonner";
import { Loader2, Sparkles, Wand2, Download } from "lucide-react";
import api, { mediaUrl, downloadUrl } from "@/lib/api";

const STYLES = [
  { id: "realista", label: "Realista", hint: "Foto realista, cine" },
  { id: "caricatura", label: "Caricatura", hint: "Ilustración / cartoon" },
];

export default function ImagePanel({ reload }) {
  const [prompt, setPrompt] = useState("");
  const [style, setStyle] = useState("realista");
  const [busy, setBusy] = useState(false);
  const [result, setResult] = useState(null);

  const generate = async () => {
    if (!prompt.trim()) { toast.error("Escribe una idea para la imagen"); return; }
    setBusy(true); setResult(null);
    try {
      const r = await api.post("/images", { prompt, style });
      setResult(r.data);
      toast.success("Imagen lista · saldo " + r.data.balance);
      reload?.();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "No se pudo generar la imagen");
    } finally { setBusy(false); }
  };

  return (
    <div className="max-w-3xl" data-testid="image-panel">
      <div className="flex items-center gap-2 mb-1">
        <Sparkles className="w-5 h-5 text-[#FF334B]" />
        <h2 className="text-lg font-head font-bold">Crear imagen desde una idea</h2>
      </div>
      <p className="text-sm text-[#94A3B8] mb-5">Describe lo que imaginas y la IA la crea. Realista o caricatura. <strong className="text-white">2 créditos</strong> por imagen.</p>

      <label className="block text-xs font-mono uppercase tracking-wider text-[#64748B] mb-1.5">Tu idea</label>
      <textarea data-testid="image-prompt" value={prompt} onChange={(e) => setPrompt(e.target.value)} rows={3}
        placeholder="Ej: un merenguero tocando la güira en un colmado al atardecer, luz cálida"
        className="w-full bg-[#12131C] border border-white/10 rounded-xl px-4 py-3 text-sm focus:border-[#FF334B] outline-none resize-none" />

      <div className="flex flex-wrap gap-2 mt-4">
        {STYLES.map((s) => (
          <button key={s.id} data-testid={`image-style-${s.id}`} onClick={() => setStyle(s.id)}
            className={`px-4 py-2 rounded-full text-sm font-semibold border transition-colors ${style === s.id ? "border-[#FF334B] bg-[#FF334B]/10 text-white" : "border-white/12 text-[#94A3B8] hover:text-white"}`}>
            {s.id === "caricatura" ? <Wand2 className="w-4 h-4 inline mr-1.5" /> : <Sparkles className="w-4 h-4 inline mr-1.5" />}
            {s.label}
          </button>
        ))}
      </div>

      <div className="mt-5 flex items-center gap-3">
        <button data-testid="image-generate-btn" onClick={generate} disabled={busy}
          className="inline-flex items-center gap-2 text-sm font-semibold px-5 py-2.5 rounded-xl bg-[#FF334B] text-white hover:bg-[#e02a40] transition-colors disabled:opacity-60">
          {busy ? <Loader2 className="w-4 h-4 spin" /> : <Sparkles className="w-4 h-4" />} Crear imagen
        </button>
        <span className="text-xs text-[#64748B]">Costo: <strong className="text-white">2 cr</strong></span>
      </div>

      {busy && <div className="mt-8 text-center text-[#94A3B8] text-sm"><Loader2 className="w-6 h-6 spin text-[#FF334B] mx-auto mb-2" /> Creando tu imagen…</div>}

      {result?.image_path && (
        <div className="mt-8" data-testid="image-result">
          <img src={mediaUrl(result.image_path)} alt="Imagen generada"
            className="w-full max-w-md rounded-2xl border border-white/10" />
          <a data-testid="image-download" href={downloadUrl(result.image_path, "metafora-imagen")}
            className="inline-flex items-center gap-1.5 mt-3 text-sm font-semibold text-[#FF334B] hover:underline">
            <Download className="w-4 h-4" /> Descargar
          </a>
        </div>
      )}
    </div>
  );
}
